/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { Transaction } from "../types";
import { fetchTransactions } from "./api";

export const getWalletTransactions = async (walletAddress: string, page = 1, limit = 5): Promise<{ transactions: Transaction[], total: number }> => {
  return await fetchTransactions(walletAddress, page, limit);
};